import { createRouter, createWebHistory } from 'vue-router'
import { getPrefix } from '@karpeleslab/klbfw'
import HomePage from './pages/HomePage.vue'
import PageView from './pages/PageView.vue'
import ProductView from './pages/ProductView.vue'
import AnnouncementView from './pages/AnnouncementView.vue'
import ArticleView from './pages/ArticleView.vue'
import ArticleListView from './pages/ArticleListView.vue'
import ContactPage from './pages/Contact.vue'
import ServicesPage from './pages/ServicesPage.vue'
import NotFound from './pages/NotFound.vue'
import RestApiDocs from './pages/RestApiDocs.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/services',
    name: 'Services',
    component: ServicesPage
  },
  {
    path: '/page/:slug',
    name: 'Page',
    component: PageView,
    props: true
  },
  {
    path: '/product/:slug',
    name: 'Product',
    component: ProductView,
    props: true
  },
  {
    path: '/announcement/:slug',
    name: 'Announcement',
    component: AnnouncementView,
    props: true
  },
  {
    path: '/article',
    name: 'ArticleList',
    component: ArticleListView
  },
  {
    path: '/article/:slug',
    name: 'Article',
    component: ArticleView,
    props: true
  },
  {
    path: '/rest/:path*',
    name: 'RestApiDocs',
    component: RestApiDocs,
    props: (route) => ({
      path: route.params.path || ''
    })
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(getPrefix() + '/'),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return { top: 0 }
  }
})

export default router